import { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";

const useFetchAllEvents = (user, ownerId = null) => {
  const [events, setEvents] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const params = useParams();
  const currentUser: any = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const entitydatalist : any = useSelector((state : RootStateOrAny) => state.user.entitydatalist);

  const fetchAllEvents = useCallback(async (user) => {
    try {
      setLoading(true);
      setError(null);
      let userEvents = user?.type === "Person" ? user.events : user?.ownedEvents;

      if (user.id !== params?.userId) {
          user = entitydatalist?.find((x) => x?.id == params?.userId) ? entitydatalist?.find((x) => x?.id == params?.userId) : user;
          userEvents = user?.type === "Person" ? user.events : user?.ownedEvents;
      }

      let nonRepeatedEvents: any = userEvents.filter(event => !event?.events || event?.events.length === 0)
      let repeatedEvents: any = userEvents.filter(event => event?.events && event?.events.length > 0);
      let allRepeatedEvents: any = [];
      for (const repeated of repeatedEvents) {
        repeated?.events?.map(repeatedEvent => {
          let tempEvent: any = {
            ...repeated,
            ...repeatedEvent,
            id: repeated?.id,
            seriesId: repeatedEvent?.id
          }
          allRepeatedEvents.push(tempEvent)
        })
      }
      // const cleanedData = allRepeatedEvents.map(({ events, ...rest }) => rest);
      let allEvents = [...nonRepeatedEvents, ...allRepeatedEvents].sort((a, b) => (new Date(a.start)).getTime() - (new Date(b.start)).getTime());
      if (ownerId) {
        allEvents = allEvents.filter((ev) => ev?.owner === ownerId);
      }
      setEvents(allEvents);
    } catch (e: any) {
      console.error("Error in fetching all Events", e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (isMounted && user) {
        await fetchAllEvents(user);
      }
    };
    fetchData();
    
    return () => {
      isMounted = false;
    };
  }, [user, fetchAllEvents]);

  return { events, loading, error };
};

export default useFetchAllEvents;